import { Controller } from '@hotwired/stimulus';

// textarea を内容に合わせて高さ自動調整する(旧 main.js の
// textarea.textarea-autosize + vendored jquery.autosize)。scrollHeight ベースの
// vanilla 実装。
export default class extends Controller {
  connect() {
    this.resize = this.resize.bind(this);
    this.element.addEventListener('input', this.resize);
    this.resize();
  }

  disconnect() {
    this.element.removeEventListener('input', this.resize);
  }

  resize() {
    const el = this.element;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  }
}
